.main {
	max-width: 1920px;
	padding: 20px 0;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	gap: 20px;
	background-color: white;
}

.section {
	max-width: 1200px;
	width: 100%;
	padding: 0;
	margin: 0 auto;
}

.items_head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
	margin-bottom: var(--text-xl);
}

.items_head h2 {
	font-size: var(--text-xl);
	font-weight: 700;
}

.query_heads {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
}

.input_wrapper {
	position: relative;
	height: 43px;
	width: 325px;
}

.input_wrapper img {
	position: absolute;
	cursor: pointer;
	left: 20px;
	top: 14px;
	bottom: 14px;
	width: 17px;
	z-index: 10;
}

.input_wrapper input {
	position: absolute;
	inset: 0;
	border-radius: 12px;
	padding: 9px 20px 9px 45px;
	background-color: var(--secondary-color-gray100);
	color: var(--secondary-color-gray400);
	z-index: 1;
}

.post_product {
	padding: 12px 23px;
	font-size: var(--text-lg);
	font-weight: 600;
	color: var(--secondary-color-gray100);
	background-color: var(--primary-color-100);
	border-radius: 8px;
	display: inline-block;
}

.select_order_by {
	padding: 12px 20px;
	background-color: white;
	font-size: var(--text-lg);
	font-weight: 400;
	color: var(--secondary-color-gray800);
}

ul.items {
	list-style-type: none;
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	margin: 0;
	padding: 0;
}

ul.items.normal {
	display: grid;
	grid-template: repeat(2, auto) / repeat(5, 1fr);
	gap: 10px;
}

ul.items li {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: flex-start;
	gap: 8px;
	margin-bottom: 30px;

	& .name {
		font-size: var(--text-lg);
		font-weight: 500;
		line-height: var(--text-2xl);
	}

	& .description {
		font-size: var(--text-md);
		font-weight: 300;
		line-height: 1.5;
	}

	& .price {
		font-size: var(--text-lg);
		font-weight: 700;
		line-height: var(--text-2xl);
	}

	& .favorite_count {
		font-size: var(--text-xs);
		font-weight: 500;
		line-height: var(--text-2lg);

		& .heart {
			font-size: 1.3em;
		}
	}
}

ul.items.best li {
	width: 24%;
}

ul.items.normal li {
	width: 100%;
}

ul.items li img {
	width: 100%;
	aspect-ratio: 1 / 1;
	border-radius: 16px;
}

.pagenation {
	display: flex;
	align-items: center;
	gap: 12.5px;
	margin: 0 auto 45px;
	justify-content: center;
}

.pagenation div {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: var(--text-4xl);
	height: var(--text-4xl);
	padding: 12.5px;
	background-color: white;
	color: var(--secondary-color-gray500);
	font-size: var(--text-lg);
	font-weight: 600;
	border-radius: 9999px;
	border: 2px solid var(--secondary-color-gray200);
}

.pagenation div:hover {
	background-color: var(--primary-color-300);
	color: white;
}

.pagenation div.disabled {
	pointer-events: none;
	background-color: rgb(216, 216, 216);
	color: var(--secondary-color-gray200);
}

.pagenation div.selected {
	background-color: var(--primary-color-100);
	color: white;
}

@media (max-width:1200px) {

	.section {
		flex-direction: column;
		margin: 0 auto;
		padding: 0 24px;
	}

	.main {
		padding: 15px;
	}

	.input_wrapper {
		width: 250px;
	}

	ul.items.normal {
		grid-template: repeat(2, auto) / repeat(3, 1fr);
	}

	ul.items.best>li {
		width: 49%;
	}
}

@media (max-width:744px) {

	.section {
		margin: 0 auto;
		padding: 0 16px;
	}

	.main {
		padding: 10px;
	}

	.head_row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: wrap;
		margin: 6px 0;
		width: 100%;
		gap: 10px;
	}

	.items_head {
		flex-direction: column;
		justify-content: space-between;
		align-items: stretch;
		gap: 12px;
	}

	.input_wrapper {
		width: 100px;
		flex-grow: 1;
	}

	ul.items.normal {
		grid-template: repeat(2, auto) / repeat(2, 1fr);
	}

	ul.items.best>li {
		width: 100%;
	}
}
